/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharp_Dark_Raven_CallInputs */

const en_sharp_dark_raven_call = /** @type {(inputs: Sharp_Dark_Raven_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PowerPoint export failed`)
};

const de_sharp_dark_raven_call = /** @type {(inputs: Sharp_Dark_Raven_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PowerPoint-Export fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "PowerPoint export failed" |
*
* @param {Sharp_Dark_Raven_CallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sharp_dark_raven_call = /** @type {((inputs?: Sharp_Dark_Raven_CallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharp_Dark_Raven_CallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharp_dark_raven_call(inputs)
	return de_sharp_dark_raven_call(inputs)
});